import { render } from "./Query.vue?vue&type=template&id=73832a0b"
import script from "./Query.vue?vue&type=script&lang=js"
export * from "./Query.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yuching/Desktop/Inncom/drbird/2202.drbird.web.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__